module.exports = __webpack_public_path__ + "static/media/mackbook.7bc98410.png";